export const groupDocumentsByType = (documentsArray) => {
    const folderMap = new Map();
    documentsArray.forEach((doc) => {
      const {
        parentDocumentId
      } = doc
      const folder = (doc.documentType || "MISC")
      const docs = new Map();
      if (!folderMap.has(folder)) {
        docs.set(parentDocumentId, [{...doc,isChecked:false}])
        folderMap.set(folder, {
          documents: docs
        })
      } else {
        const prevVal = folderMap.get(folder).documents;
        if (prevVal.has(parentDocumentId)) {
          let prevDocArr = prevVal.get(parentDocumentId);
          prevDocArr = [...prevDocArr, {...doc,isChecked:false}];
          prevVal.set(parentDocumentId, prevDocArr)
        } else {
          prevVal.set(parentDocumentId, [{...doc,isChecked:false}])
        }
      }
    })
    return folderMap;
  }
  